const STATUS_ALIASES = {
  pending: 'pending',
  approved: 'approved',
  accepted: 'approved',
  rejected: 'rejected',
  cancelled: 'cancelled',
  extended: 'extended',
};

const LABEL_BY_KEY = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  extended: 'Extended',
};

const BADGE_BY_KEY = {
  pending: 'bg-amber-50 text-amber-800 ring-1 ring-amber-200',
  approved: 'bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200',
  rejected: 'bg-red-50 text-red-700 ring-1 ring-red-200',
  cancelled: 'bg-slate-100 text-slate-700 ring-1 ring-slate-200',
  extended: 'bg-sky-50 text-sky-800 ring-1 ring-sky-200',
};

export function normalizeLeaveStatusKey(status) {
  if (status == null || status === '') return 'pending';
  const raw = String(status).trim().toLowerCase().replace(/\s+/g, '_');
  return STATUS_ALIASES[raw] || (BADGE_BY_KEY[raw] ? raw : 'pending');
}

export function formatLeaveStatusLabel(status) {
  const key = normalizeLeaveStatusKey(status);
  return LABEL_BY_KEY[key] || 'Pending';
}

export function getLeaveStatusBadgeClass(status) {
  const key = normalizeLeaveStatusKey(status);
  return BADGE_BY_KEY[key] || 'bg-gray-100 text-gray-700';
}

export function isPendingLeaveStatus(status) {
  const key = normalizeLeaveStatusKey(status);
  return key === 'pending';
}

export const LEAVE_STATUS_FILTER_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Pending', value: 'pending' },
  { label: 'Approved', value: 'approved' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Cancelled', value: 'cancelled' },
];

export const DEFAULT_LEAVE_LIST_STATUS_FILTER = 'all';
